import {
  NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_ENV_VARIANT,
  getEnvVariable
} from 'src/utils/envVariablesHelper';

export const EMPTY_STRING = '';
export const BLISTER_STRING = 'blister';

const CURRENT_ENV = getEnvVariable(NEXT_PUBLIC_ENV);
export const IS_TRACKING_DISABLED =
  CURRENT_ENV === NEXT_PUBLIC_ENV_VARIANT.STAGE ||
  CURRENT_ENV === NEXT_PUBLIC_ENV_VARIANT.DEV;
